import "./WorkflowStageSelector.css";

import { useRef, useState } from "react";

import { DropdownLightIcon } from "../../../../../../../assets";
import { stringKeyToSentenceCase, useClickOutside } from "../../../../../../../utils";

interface WorkflowStageSelectorProps {
  phases: {
    keyDates: string[];
    phase: string;
    sequence: number;
  }[];
  projectPhase: string;
  handlePhaseChange: (phase: string) => void;
}

export const WorkflowStageSelector = ({
  phases,
  projectPhase,
  handlePhaseChange,
}: WorkflowStageSelectorProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const currentPhaseIndex = phases.findIndex((item) => item.phase === projectPhase) + 1;

  useClickOutside(wrapperRef, () => setIsOpen(false));

  const handleSelectPhase = (phase: string): void => {
    handlePhaseChange(phase);
    setIsOpen(false);
  };

  return (
    <div className="WorkflowStageSelector" ref={wrapperRef}>
      <h3>Select phase</h3>
      <div className="WorkflowStageSelectorDropdown">
        <button
          aria-expanded={isOpen}
          aria-haspopup="menu"
          className="WorkflowStageSelectorTrigger"
          type="button"
          onClick={() => setIsOpen((prevIsOpen) => !prevIsOpen)}
        >
          <span>{stringKeyToSentenceCase(projectPhase)}</span>
          <DropdownLightIcon className={`WorkflowStageSelectorIcon ${isOpen ? "Open" : ""}`} />
        </button>
        {isOpen && (
          <div className="WorkflowStageSelectorMenu" role="menu">
            <p className="WorkflowStageSelectorMenuTitle">
              Phase {currentPhaseIndex} of {phases.length}
            </p>
            <div className="WorkflowStageSelectorMenuItems">
              {phases.map((item) =>
                item.phase === projectPhase ? (
                  <p key={item.phase} className="WorkflowStageSelectorMenuItem Active">
                    {stringKeyToSentenceCase(item.phase)}
                  </p>
                ) : (
                  <button
                    key={item.phase}
                    className="WorkflowStageSelectorMenuItem"
                    type="button"
                    onClick={() => handleSelectPhase(item.phase)}
                  >
                    {stringKeyToSentenceCase(item.phase)}
                  </button>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
